<template>
  <div class="content p-5">
    <div class="columns mt-5 pt-5">
      <div class="column has-text-centered">
        <h1 class="title is-2">Impressum</h1>

        <h2 class="title is-3">Angaben gem&auml;&szlig; &sect; 5 TMG</h2>
        <p>
          Frederic Fox<br />
          Hintere Dorfstr. 6<br />
          79588 Efringen-Kirchen
        </p>

        <h2 class="title is-3">Kontakt</h2>
        <p>
          Telefon: 016092201612<br />
          E-Mail: dev.frederic.fox@gmail.com
        </p>

        <p>Quelle: <a href="https://www.e-recht24.de">eRecht24</a></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  setup() {
    return {};
  },
};
</script>

<style lang="scss" scoped></style>
